import * as React from 'react';
import { TextButton, Text } from '@wix/design-system';
import { UiProvider } from '../../../providers/UiProvider';
import s from './SwitchPlanHeader.scss';

interface SwitchPlanHeaderProps {
  label: string;
  onClick?(): void;
}

export const SwitchPlanHeader: React.FC<SwitchPlanHeaderProps> = ({
  label,
  onClick,
}) => {
  return (
    <UiProvider>
      {({ t }) => (
        <div data-testid='switch-plan-header' className={s.switchPlanHeader}>
          <div
            className={s.notificationContainer}
            data-hook='switch-plan-notification'
          >
            <Text dataHook='switch-plan-notification-label' className={s.label}>
              {label}
            </Text>
            {
              onClick &&
              <TextButton
                onClick={onClick}
                className={s.viewCurrentPlanBtn}
                dataHook='view-current-plan-btn'
              >
                {t('change_plan.header.view_current_plan_advanced')}
              </TextButton>
            }
          </div>
        </div>
      )}
    </UiProvider>
  );
};
